module.exports = __webpack_public_path__ + "static/img/homev4.f89dd51.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/color/color-3/homev4.jpg
// module id = DH6V
// module chunks = 0